import React from "react";
import Notification from "../Common/Notification";
import OrderTable from "../Common/Tables/OrderTable";
import CardContent from "@mui/material/CardContent";
import { Button, Stack, Typography } from "@mui/material";
import PropTypes from "prop-types";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AddItemSalesOrderModal from "../Common/Modals/AddItemSalesOrderModal";

const CustomerSalesDetails = ({
  items,
  custom_items,
  updateItems,
  colors,
  view,
  sports,
  addNewItems,
  countryId,
  gstEnabled,
}) => {
  const enableItems = items && items?.length > 0;

  const [addModal, setAddModal] = React.useState(false);
  const closeAddModal = () => setAddModal(false);

  const handleAddItem = () => {
    setAddModal(true);
  };

  return (
    <CardContent
      sx={{ textAlign: "left", minWidth: "500px", minHeight: "576px" }}
    >
      <Stack spacing={3}>
        <Stack flexDirection={"row"} justifyContent={"space-between"}>
          <Typography fontSize={"24px"}>Order Details</Typography>
          {!view && (
            <Button
              variant="outlined"
              startIcon={<AddCircleOutlineIcon />}
              onClick={() => handleAddItem()}
            >
              New Item
            </Button>
          )}
        </Stack>

        <Notification extra="Please read and confirm details of the each item/style before continue to the next step. Use the EDIT option to update if you want to change any detail.Please note: Not all details are editable" />
        {enableItems && (
          <Stack spacing={2}>
            {items?.map((item, index) => (
              <OrderTable
                key={index}
                item={item}
                updateItems={updateItems}
                index={index}
                colors={colors}
                view={view}
                gstEnabled={gstEnabled}
              />
            ))}
            {custom_items?.map((custom_item, index) => (
              <OrderTable
                key={index}
                item={custom_item}
                updateItems={updateItems}
                index={index}
                colors={colors}
                view={view}
                type={"custom_item"}
                gstEnabled={gstEnabled}
              />
            ))}
          </Stack>
        )}
        {/* Check if view={view} needed to be from OrderTable */}
      </Stack>
      <AddItemSalesOrderModal
        handleClose={closeAddModal}
        open={addModal}
        sports={sports}
        items={items}
        addNewItems={addNewItems}
        countryId={countryId}
        gstEnabled={gstEnabled}
        colors={colors}
      />
    </CardContent>
  );
};

CustomerSalesDetails.propTypes = {
  items: PropTypes.array,
};
CustomerSalesDetails.defaultProps = {
  items: [],
};
export default CustomerSalesDetails;
